import { useSearchParams } from "react-router-dom";
import { decodeToken } from "../../../utils";

export const useAuthContextualToken = () => {
  const [searchParams] = useSearchParams();
  const queryToken = searchParams.get("token");
  const localToken = sessionStorage.getItem("token");

  const accessedByToken = !!queryToken;
  const activeToken = accessedByToken ? queryToken : localToken;
  const decoded = decodeToken(activeToken);


  let role =
    decoded?.roles?.[0]?.type?.toLowerCase?.() ||
    decoded?.role?.toLowerCase?.() ||
    decoded?.userType?.toLowerCase?.() ||
    decoded?.type?.toLowerCase?.() ||
    null;


  if (accessedByToken && !role) {
    role = "client";
  }

  return {
    accessedByToken,
    token: activeToken,
    role,
    decoded,
  };
};
